/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { DigiticketsScheduleMap } from './DigiticketsScheduleMap';
import {
    DigiticketsScheduleMapFromJSON,
    DigiticketsScheduleMapFromJSONTyped,
    DigiticketsScheduleMapToJSON,
    DigiticketsScheduleMapToJSONTyped,
} from './DigiticketsScheduleMap';

/**
 * 
 * @export
 * @interface ListDigiticketsScheduleMapsResponse
 */
export interface ListDigiticketsScheduleMapsResponse {
    /**
     * 
     * @type {Array<DigiticketsScheduleMap>}
     * @memberof ListDigiticketsScheduleMapsResponse
     */
    data: Array<DigiticketsScheduleMap>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDigiticketsScheduleMapsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDigiticketsScheduleMapsResponse interface.
 */
export function instanceOfListDigiticketsScheduleMapsResponse(value: object): value is ListDigiticketsScheduleMapsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDigiticketsScheduleMapsResponseFromJSON(json: any): ListDigiticketsScheduleMapsResponse {
    return ListDigiticketsScheduleMapsResponseFromJSONTyped(json, false);
}

export function ListDigiticketsScheduleMapsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDigiticketsScheduleMapsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(DigiticketsScheduleMapFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDigiticketsScheduleMapsResponseToJSON(json: any): ListDigiticketsScheduleMapsResponse {
      return ListDigiticketsScheduleMapsResponseToJSONTyped(json, false);
  }

  export function ListDigiticketsScheduleMapsResponseToJSONTyped(value?: ListDigiticketsScheduleMapsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(DigiticketsScheduleMapToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

